import * as req from 'api/actions';
import * as c from './constant';

export const assessReceipt = (id, payload, callback) =>
  req.update(
    c.ASSESS_RECEIPT,
    `/api/v1/administrators/transaction_histories/${id}/assess_payment_receipt`,
    payload,
    callback,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const getTransactionList = (
  payload = { module_type: 'CDL' },
  callback
) =>
  req.list(
    c.GET_TRANSACTION,
    '/api/v1/administrators/transaction_histories/',
    payload,
    callback
  );

export const showTransaction = (id, payload, callback) =>
  req.item(
    c.SHOW_TRANSACTION,
    `/api/v1/administrators/transaction_histories/${id}`,
    payload,
    callback
  );

export const updateTransaction = (id, payload, callback) =>
  req.update(
    c.UPDATE_TRANSACTION,
    `/api/v1/administrators/transaction_histories/${id}`,
    payload,
    callback,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const tagAsReceived = (id, payload, callback) =>
  req.update(
    c.TAG_AS_RECEIVED,
    `/api/v1/administrators/transaction_histories/cedula/${id}/tag_as_received`,
    payload,
    callback,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const tagAsPrintedTransaction = (id, payload, callback) =>
  req.update(
    c.TAG_AS_PRINTED_TRANSACTION,
    `/api/v1/administrators/transaction_histories/cedula/${id}/tag_as_printed`,
    payload,
    callback,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const startAssessment = (id, callback) =>
  req.update(
    c.START_ASSESSMENT,
    `/api/v1/administrators/transaction_histories/${id}/start_assessment`,
    callback,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const clearTransaction = () => req.setList(c.GET_TRANSACTION, []);

export const getSettings = (card_type, callback) =>
  req.item(c.GET_SETTINGS, `/api/v1/administrators/ohp_settings`, callback, {
    card_type,
  });

export const updatedHealthStatus = (id, payload, callback) =>
  req.update(
    c.UPDATE_TEST_STATUS,
    `/api/v1/administrators/occupational_health_permits/${id}`,
    payload,
    callback
  );

export const updateCdl = (id, payload, callback) =>
  req.update(
    c.UPDATE_CDL,
    `/api/v1/administrators/transaction_histories/cedula/individual/${id}/update`,
    payload,
    callback
  );

export const getCitizenshipList = (payload, callback) =>
  req.list(
    c.GET_CITIZENSHIP,
    '/api/v1/administrators/citizenship',
    payload,
    callback
  );

export const checkOr = (payload, callback) =>
  req.list(
    c.OR_CHECK,
    `/api/v1/administrators/transaction_histories/cedula/check_or`,
    payload,
    callback
  );

export const getRegionList = (payload, callback) =>
  req.list(
    c.GET_REGION,
    '/api/v1/administrators/address/regions',
    payload,
    callback
  );

export const getProvinceList = (payload, callback) =>
  req.list(
    c.GET_PROVINCE,
    '/api/v1/administrators/address/provinces',
    payload,
    callback
  );

export const getMunicipalityList = (payload, callback) =>
  req.list(
    c.GET_MUNICIPALITIES,
    '/api/v1/administrators/address/municipalities',
    payload,
    callback
  );

export const getBarangayList = (payload, callback) =>
  req.list(
    c.GET_BARANGAYS,
    '/api/v1/administrators/address/barangays',
    payload,
    callback
  );

export const manualPaymentApprove = (id, payload, callback) =>
  req.update(
    c.MANUAL_PAYMENT_APPROVE,
    `/api/v1/administrators/transaction_histories/${id}/manual_payment/approve`,
    payload,
    callback
  );

export const manualPaymentReject = (id, payload, callback) =>
  req.update(
    c.MANUAL_PAYMENT_APPROVE,
    `/api/v1/administrators/transaction_histories/${id}/manual_payment/reject`,
    payload,
    callback
  );

export const onApprove = (id, payload, callback) =>
  req.update(
    c.APPROVE,
    `/api/v1/administrators/transaction_histories/cedula/${id}/approve`,
    payload,
    callback
  );

export const onReject = (id, payload, callback) =>
  req.update(
    c.REJECT,
    `/api/v1/administrators/transaction_histories/cedula/${id}/reject`,
    payload,
    callback
  );

export const onRollback = (id, payload, callback) =>
  req.update(
    c.ROLLBACK,
    `/api/v1/administrators/transaction_histories/cedula/${id}/rollback`,
    payload,
    callback
  );

export const getLogs = (id, payload, callback) =>
  req.list(
    c.GET_LOGS,
    `/api/v1/administrators/transaction_histories/cedula/${id}/logs`,
    payload,
    callback
  );

export const onCancelApplication = (id, payload, callback) =>
  req.create(
    c.CANCEL_APPLICATION,
    `/api/v1/administrators/transaction_histories/cedula/${id}/cancel_application`,
    payload,
    callback
  );

export const applyDiscount = (id, payload, callback) =>
  req.update(
    c.APPLY_DISCOUNT,
    `/api/v1/administrators/transaction_histories/cedula/${id}/apply_discount`,
    payload,
    callback
  );

export const onCancelAssessment = (id, payload, callback) =>
  req.create(
    c.CANCEL_ASSESSMENT,
    `/api/v1/administrators/transaction_histories/cedula/${id}/cancel_assessment`,
    payload,
    callback
  );

export const onRevoke = (id, payload, callback) =>
  req.create(
    c.REVOKE_CEDULA,
    `/api/v1/administrators/transaction_histories/cedula/${id}/toggle_revoke`,
    payload,
    callback
  );

export const getReportAccess = (payload, callback) =>
  req.create(
    c.GET_REPORT_ACCESS,
    '/api/v1/administrators/report_access_tokens',
    payload,
    callback
  );